export default {"src":"https://fishbrain.com/_next/static/media/newYork.bb95cabe.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};